/**
 * Formats the given label with the passed parameters.
 * Be careful with the order of the passed array, since the placeholders will be replaced in the order of the array.
 * E.g. <"This is a {0} text with {1}", ["sample", "parameters"]> will return "This is a sample text with parameters".
 * @param {string} label
 * @param values
 * @returns {string}
 */
export function formatLabel(label: string, ...values: any[]): string {
	// console.log(label);
	let formattedLabel = label || '';
	if (label) {
		let count = 0;
		values.forEach((val) => {
			// console.log(val);
			formattedLabel = formattedLabel.replace('{' + count + '}', val);
			count++;
		});
	}
	return formattedLabel;
}

export default {
	formatLabel,
};
